import { rem } from "polished";

import { BlockPaddingWrapper } from "@/components/editor/shared/block-wrapper";
import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";
import { ColorLabels } from "@/components/editor/utils/use-color";

export const PaddingContainer = withViewportStyle(BlockPaddingWrapper)`
  ${(props) => props.$viewport.tablet`
    padding: ${rem(60)} ${rem(24)};
  `}

  ${(props) => props.$viewport.mobile`
    padding: ${rem(40)} ${rem(16)};
  `}
`;

export const Wrapper = withViewportStyle("div")`
  margin-bottom: ${rem(24)};

  .text-primitive {
    text-align: center;
    color: ${({ theme }) => theme.colors[ColorLabels.PRIMARY_FONT]};
  }

  ${(props) => props.$viewport.tablet`
    margin-bottom: ${rem(12)};
  `}

  ${(props) => props.$viewport.mobile`
    margin-bottom: ${rem(8)};
  `}
`;
